import ConsultantTalentContainer from './ConsultantTalentContainer';
export default ConsultantTalentContainer;